import { render } from "./Artist.vue?vue&type=template&id=12a40a9b"
import script from "./Artist.vue?vue&type=script&lang=js"
export * from "./Artist.vue?vue&type=script&lang=js"
script.render = render

export default script